/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M18.2854 0c.78 0 1.5084.3898 1.941 1.0388l2.4383 3.6574 1.333 15.638c0 2.0246-1.6412 3.6658-3.6658 3.6658H3.6659C1.6412 24 0 22.3588 0 20.3342l1.333-15.638 2.4383-3.6574A2.3328 2.3328 0 0 1 5.7123 0h12.5731Zm2.4406 5.9986H3.27L1.9994 20.3342c0 .8052.5712 1.477 1.3305 1.6324l.1655.0252.1703.0087H20.332c.9202 0 1.6663-.7461 1.6663-1.6663L20.726 5.9987ZM15.9964 8.998c.5521 0 .9998.4476.9998.9997 0 2.7608-2.2381 4.9989-4.9989 4.9989-2.7608 0-4.9989-2.2381-4.9989-4.9989 0-.5521.4476-.9997.9998-.9997s.9998.4476.9998.9997c0 1.6565 1.3428 2.9994 2.9993 2.9994 1.5875 0 2.8869-1.2333 2.9924-2.794l.0069-.2054c0-.5521.4476-.9997.9998-.9997Zm2.289-6.9984H5.7123a.3333.3333 0 0 0-.2773.1483L4.199 3.9991H19.797l-1.2342-1.8512a.3335.3335 0 0 0-.12-.109l-.0756-.0292-.0817-.0102Z"
  />,
  'MenuMarket'
);
